import { render } from "./PieceJustif.vue?vue&type=template&id=1b4adf10&scoped=true"
import script from "./PieceJustif.vue?vue&type=script&lang=js"
export * from "./PieceJustif.vue?vue&type=script&lang=js"

import "./PieceJustif.vue?vue&type=style&index=0&id=1b4adf10&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4adf10"]])

export default __exports__